import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';

export const sendNavBarAnalyticsEvent = (action: string) => () =>
  trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
    screen_name: 'Navigation Bar',
    detail: action,
  });
